module.exports = __webpack_public_path__ + "static/media/share-icon.8a5f6115.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/share-icon.svg
// module id = 465
// module chunks = 0